<template>
  <AssessmentForm @submit="onSubmit" :showSkip="!name && !age && !gender">
    <template slot="header">Thanks, tell us more</template>
    <template slot="description">
      <p>
        Each question is completely optional and you can skip at any time.
        Answers to these questions help us understand the demographic looking
        for care today to predict demand for emergency care on future days.
      </p>
    </template>
    <div class="field-container">
      <TextInput v-model="name" placeholder="Name" />
      <SelectInput v-model="age" placeholder="Age" :options="ageOptions" />
      <SelectInput
        v-model="gender"
        placeholder="Gender"
        :options="genderOptions"
      />
    </div>
  </AssessmentForm>
</template>

<script>
import AssessmentForm from '@/components/assessment-form';
import SelectInput from '@/components/select-input';
import TextInput from '@/components/text-input';
import { saveAge, saveGender, saveUserName } from '@/store';

export default {
  components: { AssessmentForm, SelectInput, TextInput },
  data() {
    return {
      name: this.$store.state.userName || '',
      age: this.$store.state.age || '',
      gender: this.$store.state.gender || '',
      isLoading: false,
    };
  },
  computed: {
    ageOptions() {
      return [
        '0 - 19 years old',
        '20 - 29 years old',
        '30 - 39 years old',
        '40 - 49 years old',
        '50 - 59 years old',
        '60 - 69 years old',
        'older than 70',
      ];
    },
    genderOptions() {
      return ['Male', 'Female'];
    },
  },
  methods: {
    async onSubmit() {
      if (this.isLoading) return;
      this.isLoading = true;
      await Promise.all([
        saveAge(this.age),
        saveGender(this.gender),
        saveUserName(this.name),
      ]);
      this.isLoading = false;
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss" scoped>
.field-container {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 400px;
}

.select-input {
  margin-top: 16px;
}
</style>
